// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item {\n  margin-bottom: 14px;\n}\n.referral-field-hint {\n  color: #777;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 6px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
